<template>
  <modal
    ref="modalComponent"
    title="Are you sure you want to delete this section?"
    submit-button-text="Delete Section"
    :show="show"
    size="md"
    :is-submitting="isSubmitting"
    @hidden="$emit('input', false)"
    @submit="onSubmit"
    :static="true"
    :lazy="true"
  >
    <b-form-group :label="'This section contains ' + tasksCount + ' initiatives'">
      <b-form-radio v-model="deleteSectionMode" name="delete-section-options" value="section-only"
        >Delete this section and retain {{ tasksCount }} initiatives</b-form-radio
      >
      <b-form-radio
        v-model="deleteSectionMode"
        name="delete-section-options"
        value="section-and-initiatives"
        >Delete this section and {{ tasksCount }} initiatives
      </b-form-radio>
    </b-form-group>
  </modal>
</template>

<script>
import Modal from '@/components/Modal.vue'
import showAPIError from '@/utils/showAPIError'
import showToast from '@/utils/showToast'
import { BFormGroup, BFormRadio } from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'

/**
 * This modal provides option to delete section. User can choose if they want to keep the initiatives under the section.
 */
export default {
  name: 'DeleteSectionModal',
  props: ['show', 'sectionId', 'tasksCount'],
  model: {
    prop: 'show'
  },
  components: { BFormRadio, BFormGroup, Modal },
  data() {
    return {
      isSubmitting: false,
      deleteSectionMode: 'section-only'
    }
  },
  computed: {
    ...mapGetters('project', ['sectionById']),
    section() {
      return this.sectionById(this.sectionId)
    }
  },
  methods: {
    ...mapActions('project', ['deleteSection']),
    async onSubmit() {
      try {
        this.isSubmitting = true
        await this.deleteSection({
          orgId: this.section.organizationId,
          sectionId: this.sectionId,
          params: {
            mode: this.deleteSectionMode
          }
        })
        this.$emit('deleted')
        this.$refs.modalComponent.hide()
        showToast('Section has been deleted successfully')
      } catch (e) {
        showAPIError(e)
      }
      this.isSubmitting = false
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
